import { render, staticRenderFns } from "./ThirdPartyWarning.vue?vue&type=template&id=d65933a8&lang=pug&"
import script from "./ThirdPartyWarning.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports